// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

const styles = (theme) =>({
  grid: {
    padding: "0 15px !important"
  }
});


export default function GridItem(props) {
  
  const { children, ...rest } = props;
  const theme = useTheme();

 

  return (
    <Grid item {...rest} sx={{
        padding: "0 15px",
        [theme.breakpoints.down("sm")]: {
          padding: "0 10px",
        },
      }}>
      {children}
    </Grid>
  );
}

GridItem.propTypes = {
  children: PropTypes.node
};
